import { Grid } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import useUser from 'store/user/useUser';
import { useMainLayout } from '../useMainLayout';
import CollegePatientList from './CollegePatientList';

import PatientsList from './PatientsList';
import StudentList from './StudentList';
import ClassSectionList from './ClassSectionList';

const professorMobileFieldSx = {
  width: '100%',
  '& .MuiAutocomplete-root': {
    display: 'block',
  },
  '& .MuiInputBase-root': {
    minHeight: 40,
    alignItems: 'center',
  },
  '& .MuiInputBase-input': {
    py: 1,
  },
};

const SearchToolbar = () => {
  const { student_uuid: user_id, isStudent } = useUser();
  const { isDesktopLayout } = useMainLayout();
  const isProfessorMobile = !isDesktopLayout && !isStudent;

  return (
    <Grid
      container
      alignItems="center"
      spacing={isProfessorMobile ? 2 : 1}
      sx={{
        zIndex: zIndex.modal,
        width: '100%',
      }}
    >
      {isStudent ? (
        <Grid item xs={12}>
          <PatientsList user_id={user_id} />
        </Grid>
      ) : (
        <>
          <Grid
            item
            xs={12}
            md={4}
            sx={isProfessorMobile ? professorMobileFieldSx : undefined}
          >
            <CollegePatientList user_id={user_id} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={isProfessorMobile ? professorMobileFieldSx : undefined}
          >
            <ClassSectionList user_id={user_id} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={isProfessorMobile ? professorMobileFieldSx : undefined}
          >
            <StudentList user_id={user_id} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SearchToolbar;
